import { useMutation, useQuery } from "@tanstack/react-query";
import {
  enrollCourse,
  getCourse,
  getCoursePicture,
  getCourses,
  getStudentRatingCourses,
} from "@/api/query/courses";
import toast from "react-hot-toast";
import { useRouter } from "next/navigation";

export const useTopCourses = () => {
  return useQuery({
    queryKey: ["topCourses"],
    queryFn: getCourses,
  });
};

export const useCoursePicture = (courseId: number) => {
  return useQuery({
    queryKey: ["coursePicture", courseId],
    queryFn: () => getCoursePicture(courseId),
    staleTime: Infinity, // Cache the image permanently since it's unlikely to change
  });
};

export const useIndividualCourse = (courseId: number) => {
  return useQuery({
    queryKey: ["course", courseId],
    queryFn: async () => getCourse(courseId),
  });
};

export const useEnrollCourse = () => {
  const router = useRouter();
  return useMutation({
    mutationFn: async (courseId: number) => enrollCourse(courseId),
    onSuccess: () => {
      toast.success("Successfully enrolled in the course!");
    },
    onError: (error: any) => {
      toast.error(
        error.response?.data?.message || "Sign-in to your account to enroll"
      );
      router.push("/sign-in");
    },
  });
};

export const useStudentRatingCourses = (studentId: number) => {
  return useQuery({
    queryKey: ["student-courses", studentId],
    queryFn: async () => getStudentRatingCourses(studentId),
    enabled: !!studentId,
  });
};
